module.exports = __webpack_public_path__ + "img/btn_stroke_on.5323c944.svg";